import { render, staticRenderFns } from "./StatusButton.vue?vue&type=template&id=63b6adda"
import script from "./StatusButton.vue?vue&type=script&lang=js"
export * from "./StatusButton.vue?vue&type=script&lang=js"
import style0 from "./StatusButton.vue?vue&type=style&index=0&id=63b6adda&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports